import Loader from '../../../../utils/Loader'

export default function Login() {
  return <Loader />
}
